
import {onMounted, reactive, ref} from 'vue'
import AxiosAdapter from '../request/AxiosAdapter'
import {throwCustomFunction} from '@/commons/ErrorHandle'
import {useRoute} from 'vue-router'
import SelectIdentityType from './SelectIdentityType.vue'
// import GetImageConversion from '../commons/ImageConversion'
import {acceptImage} from '@/commons/unit'

export default {
  name: 'UserType',
  props: {
    // courtId: String,
    userType: Number,
    proxyType: Number
  },
  components: {SelectIdentityType},
  setup(props: any, context: any) {
    const courtId = ref()
    const identityType = ref(1)
    const proxyIdentityType = ref(1)
    const agentIdentityType = ref(1)
    const proxy = ref(false)
    const acceptImageUrl = ref(acceptImage)
    const selectOptions = reactive({
      userTypeList: [
        {
          code: 1,
          msg: '本人',
          img: require('@/assets/img/upload_user.png'),
          imgChe: require('@/assets/img/upload_user_che.png')
        },
        {
          code: 2,
          msg: '代理人',
          img: require('@/assets/img/agent.png'),
          imgChe: require('@/assets/img/agent_che.png')
        }
      ],
      userTypeOptions: [
        {
          label: '自然人',
          value: 1
        },
        {
          label: '法定代表人',
          value: 2
        }
      ],
      proxyTypeOptions: [
        {
          label: '法律职业者',
          value: 3
        },
        {
          label: '近亲属',
          value: 4
        },
        {
          label: '员工',
          value: 5
        }
      ]
    })
    const route = useRoute()
    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const caseUser: any[] = []
      const caseUsers: any[] = []
    const identityPhotoBackUrl: any[] = []
       const identityPhotoBackUrls: any[] = []
    const userHandleSuccessHide:any = ref(false)
    const legalIdentity: any[] = []
     const legalIdentitys: any[] = []
    const legalWorkIdentity: any[] = []
       const legalWorkIdentitys: any[] = []
    const delegationUrl: any[] = []
        const delegationUrls: any[] = []
    const hirePaperworkUrl: any[] = []
        const hirePaperworkUrls: any[] = []
    const agentUser: any[] = []
       const agentUsers: any[] = []
    const agentUserBack: any[] = []
        const agentUserBacks: any[] = []
    const proxyIdentityPhotoBackUrl: any[] = []
        const proxyIdentityPhotoBackUrls: any[] = []
    const agentProxy: any[] = []
    const agentTrust: any[] = []
    const agentOther: any[] = []
    const mediationConfirmUrl: any[] = []
        const agentProxys: any[] = []
    const agentTrusts: any[] = []
    const agentOthers: any[] = []
    const mediationConfirmUrls: any[] = []
    const getUrl = process.env.VUE_APP_BASE_API
    const colNum = ref(1)
    // const userValue = ref(1)
    // const proxyValue = ref(1)
    const urlsList = reactive({
      caseUser: caseUser, //本人自然人 当事人身份证明
      identityPhotoBackUrl: identityPhotoBackUrl, // 本人背面
      legalIdentity: legalIdentity, //本人法人  当事人身份证明
      legalWorkIdentity: legalWorkIdentity, //本人法人 营业执照副本
      hirePaperworkUrl: hirePaperworkUrl, //本人法人 任职书
      delegationUrl: delegationUrl, //本人法人 委托函
      agentUser: agentUser, //代理人 当事人身份证明
      agentUserBack: agentUserBack, // 代理人 代理人身份证背面
      proxyIdentityPhotoBackUrl: proxyIdentityPhotoBackUrl, // 代理人 代理人背面
      agentProxy: agentProxy, // 代理人 代理人身份证明
      agentTrust: agentTrust, // 代理人 授权委托书
      agentOther: agentOther, // 代理人 其他
      mediationConfirmUrl: mediationConfirmUrl // 调解确认书
    })
        const urlsListParams = reactive({
      caseUsers: caseUsers, //本人自然人 当事人身份证明
      identityPhotoBackUrls: identityPhotoBackUrls, // 本人背面
      legalIdentitys: legalIdentitys, //本人法人  当事人身份证明
      legalWorkIdentitys: legalWorkIdentitys, //本人法人 营业执照副本
      hirePaperworkUrls: hirePaperworkUrls, //本人法人 任职书
      delegationUrls: delegationUrls, //本人法人 委托函
      agentUsers: agentUsers, //代理人 当事人身份证明
      agentUserBacks: agentUserBacks, // 代理人 代理人身份证背面
      proxyIdentityPhotoBackUrls: proxyIdentityPhotoBackUrls, // 代理人 代理人背面
      agentProxys: agentProxys, // 代理人 代理人身份证明
      agentTrusts: agentTrusts, // 代理人 授权委托书
      agentOthers: agentOthers, // 代理人 其他
      mediationConfirmUrls: mediationConfirmUrls // 调解确认书
    })

    onMounted(() => {
      if (route.query.courtId) {
        courtId.value = route.query.courtId
      }
    })

    const changeIdentityType = (val: any) => {
      identityType.value = val
      // 当事人
      urlsList.caseUser.length = 0
      urlsList.identityPhotoBackUrl.length = 0
      urlsList.caseUser = []
      urlsList.identityPhotoBackUrl=[]
      urlsListParams.caseUsers = []
      urlsListParams.identityPhotoBackUrls =[]
    }
    const changeAgentIdentityType = (val: any) => {
      agentIdentityType.value = val
      //代理人
      urlsList.agentUser.length = 0
      urlsList.agentUser =[]
      urlsList.agentUserBack.length = 0
      urlsList.agentUserBack = []
      urlsListParams.agentUsers =[]
      urlsListParams.agentUserBacks =[]
    }
    const changeProxyIdentityType = (val: any) => {
      proxyIdentityType.value = val
      urlsList.agentProxy.length = 0
      urlsList.proxyIdentityPhotoBackUrl.length = 0
       urlsListParams.agentProxys =[]
   urlsListParams.proxyIdentityPhotoBackUrls=[]
    }

    // const successUpload = (type: any, res?: any) => {
    // const url = res && res.value && res.value[0]
    // const list: any = urlsList[type] as any
    // list.push(url)
    // }
    const userHandleSuccess = (res: any) => {
      // successUpload('caseUser', res)
      const url = res
    }
    const userBackHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.identityPhotoBackUrl.push(url)
    }
    const legalIdentityHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.legalIdentity.push(url)
    }
    const legalWorkIdentityHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.legalWorkIdentity.push(url)
    }
    const hirePaperworkUrlHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.hirePaperworkUrl.push(url)
    }
    const delegationUrlHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.delegationUrl.push(url)
    }

    const agentUserHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.agentUser.push(url)
    }
    const agentUserBackHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.agentUserBack.push(url)
    }
    const agentProxyHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.agentProxy.push(url)
    }
    const agentProxyBackHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.proxyIdentityPhotoBackUrl.push(url)
    }
    const agentTrustHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.agentTrust.push(url)
    }
    const agentOtherHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.agentOther.push(url)
    }

    const mediationConfirmUrlHandleSuccess = (res: any) => {
      const url = res && res.value && res.value[0]
      urlsList.mediationConfirmUrl.push(url)
    }

    const userUploadFun = async () => {
      const params: any = {
        identityPhotoUrl: '',
        identityPhotoBackUrl: '',
        proxyIdentityPhotoUrl: '',
        proxyIdentityPhotoBackUrl: '',
        legalIdentity: '',
        legalWorkIdentity: '',
        hirePaperworkUrl: '',
        delegationUrl: '',
        agentUser: '',
        agentProxy: '',
        agentTrust: '',
        agentOther: '',
        mediationConfirmUrl: '',
        courtId: route.query.courtId,
        userType: props.userType,
        proxyType: props.proxyType
      }
      if (props.userType == 1) {
        if (props.proxyType == 1) {
          if (urlsListParams.caseUsers.length < 1) {
            throwCustomFunction('请上传当事人身份证明')
          }
          params.identityPhotoUrl = urlsListParams.caseUsers.toString()
          params.identityPhotoBackUrl = urlsListParams.identityPhotoBackUrls.toString()
        }
        if (props.proxyType == 2) {
          if (urlsListParams.legalIdentitys.length < 1) {
            throwCustomFunction('请上传当事人身份证明')
          }
          if (urlsListParams.legalWorkIdentitys.length < 1) {
            throwCustomFunction('请上传营业执照副本')
          }
          params.identityPhotoUrl = urlsListParams.legalIdentitys.toString()
          params.identityPhotoBackUrl = urlsListParams.identityPhotoBackUrls.toString()
          params.companyCertificateUrl = urlsListParams.legalWorkIdentitys.toString()
          // if (courtId.value == '110102' || courtId.value == '110114') {
            params.hirePaperworkUrl = urlsListParams.hirePaperworkUrls.toString()
            params.delegationUrl = urlsListParams.delegationUrls.toString()
          // }
        }
        if (urlsListParams.mediationConfirmUrls){
          params.mediationConfirmUrl = urlsListParams.mediationConfirmUrls.toString()
        }

        if (
            identityType.value === 1 &&
            urlsListParams.identityPhotoBackUrls.length < 1
        ) {
          throwCustomFunction('请上传当事人身份证明背面')
        }
      }
      if (props.userType == 2) {
        if (urlsListParams.agentUsers.length < 1) {
          throwCustomFunction('请上传当事人身份证明')
        }
        if (
            agentIdentityType.value === 1 &&
            urlsListParams.agentUserBacks.length < 1
        ) {
          throwCustomFunction('请上传当事人身份证明背面')
        }
        if (urlsListParams.agentProxys.length < 1) {
          throwCustomFunction('请上传代理人身份证明')
        }
        if (
            proxyIdentityType.value === 1 &&
            urlsListParams.proxyIdentityPhotoBackUrls.length < 1
        ) {
          throwCustomFunction('请上传代理人身份证明背面')
        }
        if (urlsListParams.agentTrusts.length < 1) {
          throwCustomFunction('请上传授权委托书')
        }

        params.identityPhotoUrl = urlsListParams.agentUsers.toString()
        params.identityPhotoBackUrl = urlsListParams.agentUserBacks.toString()
        params.proxyIdentityPhotoUrl = urlsListParams.agentProxys.toString()
        params.proxyIdentityPhotoBackUrl =
            urlsListParams.proxyIdentityPhotoBackUrls.toString()
        params.delegationUrl = urlsListParams.agentTrusts.toString()
        params.otherUrl = urlsListParams.agentOthers.toString()
      }


      // params.courtId = props.courtId
      // params.userType = props.userType
      // params.proxyType = props.proxyType

      const data: any = await AxiosAdapter.post({
        url: '/confirmAddress/addWestCityPicture',
        data: params
      })
      context.emit('nextuser', data)
    }
    const userHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.caseUser.indexOf(item)
      urlsListParams.caseUsers.splice(index, 1)
      if (index !== -1) {
        urlsList.caseUser.splice(index, 1)
        
      }
    }
    const userBackHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.identityPhotoBackUrl.indexOf(item)
              urlsListParams.identityPhotoBackUrls.splice(index, 1)
      if (index !== -1) {
        urlsList.identityPhotoBackUrl.splice(index, 1)
      }
    }
    const legalIdentityHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.legalIdentity.indexOf(item)
      urlsListParams.legalIdentitys.splice(index, 1)
      if (index !== -1) {
        urlsList.legalIdentity.splice(index, 1)
      }
    }
    const legalWorkIdentityHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.legalWorkIdentity.indexOf(item)
       urlsListParams.legalWorkIdentitys.splice(index, 1)
      if (index !== -1) {
        urlsList.legalWorkIdentity.splice(index, 1)
      }
    }

    const hirePaperworkUrlHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.hirePaperworkUrl.indexOf(item)
       urlsListParams.hirePaperworkUrls.splice(index, 1)
      if (index !== -1) {
        urlsList.hirePaperworkUrl.splice(index, 1)
      }
    }

    const delegationUrlHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.delegationUrl.indexOf(item)
       urlsListParams.delegationUrls.splice(index, 1)
      if (index !== -1) {
        urlsList.delegationUrl.splice(index, 1)
      }
    }
    const agentUserHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.agentUser.indexOf(item)
       urlsListParams.agentUsers.splice(index, 1)
      if (index !== -1) {
        urlsList.agentUser.splice(index, 1)
      }
    }
    const agentUserBackHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.agentUserBack.indexOf(item)
        urlsListParams.agentUserBacks.splice(index, 1)
      if (index !== -1) {
        urlsList.agentUserBack.splice(index, 1)
      }
    }
    const agentProxyBackHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.proxyIdentityPhotoBackUrl.indexOf(item)
       urlsListParams.proxyIdentityPhotoBackUrls.splice(index, 1)
      if (index !== -1) {
        urlsList.proxyIdentityPhotoBackUrl.splice(index, 1)
      }
    }
    const agentProxyHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.agentProxy.indexOf(item)
       urlsListParams.agentProxys.splice(index, 1)
      if (index !== -1) {
        urlsList.agentProxy.splice(index, 1)
      }
    }
    const agentTrustHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.agentTrust.indexOf(item)
       urlsListParams.agentTrusts.splice(index, 1)
      if (index !== -1) {
        urlsList.agentTrust.splice(index, 1)
      }
    }
    const agentOtherHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.agentOther.indexOf(item)
       urlsListParams.agentOthers.splice(index, 1)
      if (index !== -1) {
        urlsList.agentOther.splice(index, 1)
      }
    }


    const mediationConfirmUrlHandleRemove = (file: any) => {
      const item =
          file && file.response
              ? file.response.value[0]
              : file.url.replace(getUrl, '')
      const index = urlsList.mediationConfirmUrl.indexOf(item)
          urlsListParams.mediationConfirmUrls.splice(index, 1)
      if (index !== -1) {
        urlsList.mediationConfirmUrl.splice(index, 1)
      }
    }

    const getList = (urls?: any) => {
      if (!urls) return
      const arr: any[] = []
      urls.forEach((current: any) => {
        if (current) {
          arr.push({url: getUrl + current})
        }
      })
      return arr
    }
    const getUserList = (urls?: any) => {
      return getList(urls)
    }
    const getUserBackList = (urls?: any) => {
      return getList(urls)
    }
    const getProxyList = (urls?: any) => {
      return getList(urls)
    }
    const getProxyBackList = (urls?: any) => {
      return getList(urls)
    }
    const getTrustList = (urls?: any) => {
      return getList(urls)
    }
    const getOtherList = (urls?: any) => {
      return getList(urls)
    }

    function beforeUpload(file: File,data:any) { 
      const formData = new FormData()
      formData.append('file', file)
      formData.append('type', '20')
      formData.append('courtId', courtId.value)

      AxiosAdapter.post({
        url: '/file/uploadConfirmAddressFile',
        data: formData,
      }).then((res: any) => {
        // 假设服务器返回的文件路径在 res.data.value[0]
        const filePath = res[0] || ''
        if (!filePath) {
          throwCustomFunction('上传失败，未获取到文件路径')
          return
        }
        if(data === 'userHandleSuccess'){
       urlsListParams.caseUsers.push(filePath)
        // urlsList.caseUser,
        // let num = 0
        //  identityType.value > 1 ?num = 3 : num=1
        //  if(urlsListParams.caseUser.length=== num){
        //   userHandleSuccessHide.value = true
        //  }else{
        //   userHandleSuccessHide.value = false
        //  }
        }else if(data === 'userBackHandleSuccess'){
       urlsListParams.identityPhotoBackUrls.push(filePath)
        }else if(data === 'legalIdentityHandleSuccess'){
       urlsListParams.legalIdentitys.push(filePath)
        }else if(data === 'legalWorkIdentityHandleSuccess'){
       urlsListParams.legalWorkIdentitys.push(filePath)
        }else if (data === 'hirePaperworkUrlHandleSuccess'){
        urlsListParams.hirePaperworkUrls.push(filePath)
        }else if (data === 'delegationUrlHandleSuccess'){
    urlsListParams.delegationUrls.push(filePath)
        }else if(data === 'mediationConfirmUrlHandleSuccess'){
   urlsListParams.mediationConfirmUrls.push(filePath)
        }else if(data==='agentUserHandleSuccess'){
   urlsListParams.agentUsers.push(filePath)
        }else if(data==='agentUserBackHandleSuccess'){
urlsListParams.agentUserBacks.push(filePath)
        }else if(data==='agentProxyHandleSuccess'){
urlsListParams.agentProxys.push(filePath)
        }else if(data==='agentProxyBackHandleSuccess'){
    urlsListParams.proxyIdentityPhotoBackUrls.push(filePath)
        }else if(data==='agentTrustHandleSuccess'){
urlsListParams.agentTrusts.push(filePath)
        }else if(data==='agentOtherHandleSuccess'){
   urlsListParams.agentOthers.push(filePath)
        }
        // 将服务器返回的路径存储在 file 的自定义属性中
             
       return true
      }).catch((error: any) => {
        console.error('上传失败:', error)
      })

      const uid = `${Date.now()}-${Math.random()}`;
      const url = URL.createObjectURL(file);
      (file as any).uid = uid;
      (file as any).url = url;
      return true;
    }

    const handlePictureCardPreview = async (file: any) => {
      dialogImageUrl.value = file.url
      dialogVisible.value = true
    }

   const isHide = (arr: [], count: any) => {
      const bool = arr.length === count
      return bool
    }


    return {
      getUserList,
      getProxyList,
      getTrustList,
      getOtherList,
      dialogImageUrl,
      dialogVisible,
      getUserBackList,
      getProxyBackList,
      courtId,
      userHandleSuccessHide,
      legalIdentityHandleRemove,
      legalWorkIdentityHandleRemove,
      hirePaperworkUrlHandleRemove,
      delegationUrlHandleRemove,
      agentUserHandleRemove,
      getList,
      handlePictureCardPreview,
      agentTrustHandleRemove,
      agentOtherHandleRemove,
      userUploadFun,
      agentProxyHandleRemove,
      agentProxyHandleSuccess,
      mediationConfirmUrlHandleRemove,
      acceptImageUrl,
     userHandleSuccess,
      legalIdentityHandleSuccess,
      legalWorkIdentityHandleSuccess,
      hirePaperworkUrlHandleSuccess,
      delegationUrlHandleSuccess,
      agentUserHandleSuccess, 
      agentTrustHandleSuccess,
      mediationConfirmUrlHandleSuccess,
      agentOtherHandleSuccess,
      selectOptions,
      colNum,
      userHandleRemove,
      urlsList,
      urlsListParams,
      getUrl,
      beforeUpload,
      identityType,
      changeIdentityType,
      userBackHandleSuccess,
      userBackHandleRemove,
      proxy,
      changeProxyIdentityType,
      proxyIdentityType,
      agentIdentityType,
      changeAgentIdentityType,
      agentProxyBackHandleSuccess,
      agentProxyBackHandleRemove,
      agentUserBackHandleSuccess,
      agentUserBackHandleRemove,
      isHide
    }
  }
}
